import React, { useEffect, useState } from "react";
import "./CgFileUploader.scss";

const CgFileUploader = ({
  maxFileSize = 2 * 1024 * 1024,
  onFileUploadCallback = () => {},
  name,
  label,
  descriptionChangeCallBack,
  renderCustom,
  isCustom = false,
  listUploadedFile = true,
  fileType = "file",
  disable = false,
}) => {
  const [file, setFile] = useState(null);
  const [showPreview, setShowPreview] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [fileContent, setFileContent] = useState("");
  const [fileURL, setFileURL] = useState("");
  const [value, setValue] = useState();
  // const [dragActive, setDragActive] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setSuccessMsg("");
    }, 2000);
  }, [successMsg]);
  const allowedTypes = [
    "application/pdf",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "image/svg+xml",
    "image/jpeg",
    "image/png",
  ];

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    handleFile(selectedFile);
  };

  const handleFile = (selectedFile) => {
    if (!selectedFile) return;
    if (!allowedTypes.includes(selectedFile.type)) {
      alert(
        "Invalid file type. Only PDF, DOCX, DOC, SVG, JPG, JPEG, and PNG are allowed."
      );
      resetFile();
      return;
    }

    if (selectedFile.size > maxFileSize) {
      alert(
        `File size exceeds the limit of ${(maxFileSize / (1024 * 1024)).toFixed(
          2
        )} MB.`
      );
      resetFile();
      return;
    }

    setFile(selectedFile);
    setFileURL(URL.createObjectURL(selectedFile));
    readFileContent(selectedFile);
    const data = {
      URL: URL.createObjectURL(selectedFile),
      FILE: selectedFile,
    };
    onFileUploadCallback(data);
    setSuccessMsg("File Uploaded Successfully");
  };

  const handleChange = (e) => {
    const value = e.target.value;
    // console.log(value);
    setValue(value);
  };

  const handleBlur = () => {
    descriptionChangeCallBack(name, value);
  };

  const resetFile = () => {
    setFile(null);
    setFileContent("");
    setFileURL("");
  };

  const readFileContent = (file) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      setFileContent(e.target.result);
    };
    if (!file.type.startsWith("image/")) {
      reader.readAsText(file);
    }
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    // setDragActive(true);
  };

  const handleDragLeave = () => {
    // setDragActive(false);
  };

  const handleDrop = (event) => {
    event.preventDefault();
    // setDragActive(false);
    const droppedFile = event.dataTransfer.files[0];
    handleFile(droppedFile);
  };

  const openInNewTabAndDownload = () => {
    const newTab = window.open(fileURL, "_blank");
    const link = document.createElement("a");
    link.href = fileURL;
    link.download = file.name;
    link.click();
    newTab.focus();
  };

  return (
    <div className="cgFileUploadWrapper" style={{ display: "flex" }}>
      <div className={` cgFileContentItem ${disable ? "disable" : ""}`}>
        {label && <label className="form-label">{label}</label>}
        <div
          className="fileUploaderBody"
          onDragOver={handleDragOver}
          onDragLeave={handleDragLeave}
          onDrop={handleDrop}
          onClick={() => document.getElementById("fileInput").click()}
        >
          {isCustom ? (
            <>{renderCustom()}</>
          ) : (
            <div className="fileUploader">
              Simply drag files here or
              <span className="linkBtn" style={{ fontSize: "17px" }}>
                Browse
              </span>
            </div>
          )}
          <input
            style={{ display: "none" }}
            id="fileInput"
            name={name}
            type="file"
            accept=".pdf, .docx, .doc, .svg, .jpg, .jpeg, .png"
            onChange={handleFileChange}
            className="hidden"
          />
        </div>
        {/* {successMsg && (
        <div
          className="alert alert-success"
          style={{ position: "absolute", zIndex: 1000000 }}
          role="alert"
        >
          {successMsg}
        </div>
      )} */}
        {file === "newFile" && (
          <button
            className="mt-4 text-blue-500 underline cursor-pointer"
            onClick={() => setShowPreview(!showPreview)}
          >
            Documents
          </button>
        )}
        {showPreview && file && (
          <div className="mt-4 p-2 border rounded">
            <p>
              <strong>File Name:</strong> {file.name}
            </p>
            <p>
              <strong>File Size:</strong> {(file.size / 1024).toFixed(2)} KB
            </p>
            <div
              className="text-blue-600 underline block mt-2 cursor-pointer"
              onClick={openInNewTabAndDownload}
            >
              Open in new page
            </div>
            {file.type.startsWith("image/") && (
              <img
                src={fileURL}
                alt="Preview"
                className="mt-2 max-w-full h-auto cursor-pointer"
                onClick={openInNewTabAndDownload}
              />
            )}
            {fileContent && !file.type.startsWith("image/") && (
              <pre
                className="mt-2 p-2 border rounded bg-gray-100 overflow-auto max-h-60 cursor-pointer"
                onClick={openInNewTabAndDownload}
              >
                {fileContent}
              </pre>
            )}
          </div>
        )}
      </div>
      {file && listUploadedFile && (
        <div className="">
          <div className="uploadedFileListWrapper">
            <div className="uploadedFileLabel">
              {fileType !== "image" ? (
                <>{file.name}</>
              ) : (
                <>
                  <img />
                </>
              )}
              <button
                className="remove"
                onClick={() => {
                  setFile(null);
                  setFileURL(null);
                  setFileContent(null);
                  setValue(null);
                  onFileUploadCallback();
                }}
              >
                x
              </button>
            </div>
            <div className="uploaddesc">
              <input
                placeholder="Enter file description"
                value={value}
                onChange={handleChange}
                onBlur={handleBlur}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CgFileUploader;
